module.exports = __webpack_public_path__ + "static/js/0.eaace414.chunk.worker.js"